import { TableColumn } from "../../types";
import { ExternalLink } from "../../components/ExternalLink";
import { WorkloadTableItem } from "../../../../mst/kinds/workload.helpers";

const typeDefault = { id: "type", label: "Type" };
export function WorkloadTypeColumn<TData extends WorkloadTableItem>(column: TableColumn<TData> = typeDefault) {
  const preset: TableColumn<TData> = {
    ...typeDefault,
    size: 230,
    enableSort: true,
    serverSortProperty: "spec.type",
    cell: (p) => {
      const workload = p.row.original;
      return (
        <div className="flex items-center w-full justify-between">
          <div>
            {workload.type.slice(0, 1).toUpperCase()}
            {workload.type.slice(1)}
          </div>
          {workload.status?.canonicalEndpoint ? (
            <ExternalLink label="Open" url={workload.status.canonicalEndpoint} />
          ) : null}
        </div>
      );
    },
  };
  return Object.assign(preset, column);
}
